export function openForm (state, event) {
	state.event = { ...event };

	state.isFormOpen = true;
}
